import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class CompareBuyWithUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            tab: {}
        };
    };

    componentWillMount() {}

    componentDidMount() {
        this.setState({
            tab: this.props.tab
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tab: nextProps.tab
        })
    }

    _items() {
        let items = [];
        if(this.state.tab && this.state.tab.id === 1){
            items = [
                {
                    title: "On-plan property",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Assured future payouts",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Assured future solvency",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "All yield banked up-front",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "A+ grade deposit",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Smart contract",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Fees (excl dld / agent fees)",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "0,5% + admin"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Overall risk",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "low"},
                    offplan: {exist: true, value: "high"}
                }
            ];
        }else if(this.state.tab && this.state.tab.id === 2){
            items = [
                {
                    title: "Get over market price",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Earn rent after you sell",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "up to 7 years"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Sell faster",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Smart contract",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "–"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Fees",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "0,5% + admin"},
                    offplan: {exist: true, value: "–"}
                },
                {
                    title: "Total value release",
                    classic: {exist: true, value: "–"},
                    yieldlock: {exist: true, value: "up to 125%"},
                    offplan: {exist: true, value: "100%"}
                }
            ];
        }
        return items;
    }

    boost(){
        window.scrollTo(0, 0);
    }

    _renderText(item) {
        return langRegister.get("home-sections-eight", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.table}>
                        <div className={cx(Styles.tableItem)}>
                            <div className={cx(Styles.tableSectionOne)}/>
                            <div className={cx(Styles.tableSectionTwo, Styles.tableItemTop)}>
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableTitle}>
                                    With us
                                </div>
                            </div>
                            <div className={cx(Styles.tableSectionThree, Styles.tableItemTop)}>
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableTitle}>
                                    Off-plan
                                </div>
                            </div>
                        </div>
                        {
                            this._items().map((item, key) => {
                                return (
                                    <div className={Styles.tableItem}>
                                        <div className={
                                            cx(Styles.tableSectionOne,
                                                {
                                                    [Styles.tableSectionOneOther]: salesChannelRegister.get("name") !== "yieldlock"
                                                })
                                        }>
                                            <div style={{color: '#00273A'}} className={Styles.tableSectionOneTitle}>
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionTwo,
                                                {
                                                    [Styles.tableSectionTwoActive]: item.yieldlock.exist,
                                                    [Styles.tableSectionTwoActiveFirst]: key === 0,
                                                    [Styles.tableSectionTwoActiveLast]: key === this._items().length - 1,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitle}>
                                                {
                                                    item.yieldlock.value === '–' &&
                                                    <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_YL.png")}/>
                                                }
                                                {
                                                    item.yieldlock.value !== '–' &&
                                                    <span className={Styles.tableSectionTitleSecond}>{item.yieldlock.value}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionThree,
                                                {
                                                    [Styles.tableSectionThreeActive]: item.offplan.exist,
                                                })
                                        }>
                                            {
                                                item.offplan.value === '–' &&
                                                <div style={{color: '#00273A'}} className={Styles.tableSectionTitleSecondGray}>
                                                    {item.offplan.value}
                                                </div>
                                            }
                                            {
                                                item.offplan.value !== '–' && item.offplan.value !== 'checkmark' &&
                                                <div style={{color: '#00273A'}} className={Styles.tableSectionTitleSecondDarkBlue}>
                                                    {item.offplan.value}
                                                </div>
                                            }
                                            {
                                                item.offplan.value === 'checkmark' &&
                                                <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default CompareBuyWithUs;


// WEBPACK FOOTER //
// ./src/components/compare-buy-with-us/component.js